import { useEffect, useState } from "react"
import { Graph, Node } from '@antv/x6'
import { UnitTagState } from "../services/modal"
import { Input } from "antd"
import { useEditorEventBusInstance } from "../events/useEventBusInstance"

export const UnitTagNode = ({node, graph}: {node: Node, graph: Graph}) => {
  const data: UnitTagState = node.getData()
  const { text: value } = data
  const eventBus = useEditorEventBusInstance()

  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(value);

  useEffect(() => {
    setText(value)
  }, [value])

  const handleDoubleClick = () => {
    setIsEditing(true);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };

  const handleBlur = () => {
    setIsEditing(false);
    const targetNode = graph.getCellById(data.unit)
    targetNode.setData({...targetNode.getData(), tag: text})
    eventBus.trigger('updateCell', targetNode)
  };

  return (
    <>
      {isEditing ? (
        <Input
          value={text}
          onChange={handleChange}
          onBlur={handleBlur}
          onPressEnter={handleBlur}
          autoFocus
          style={{
            width: '100%',
            height: 24,
            textAlign: 'center'
          }}
        />
      ) : (
        <div onDoubleClick={handleDoubleClick} style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
            {text}
        </div>
      )}
    </>
  );
}

